import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  containerText: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "10px 0px",
    minWidth: "min(380px, 78vw)",
    width: "100%",
    boxSizing: "border-box",
  },
  errorText: {
    color: "#EF4444",
    fontSize: "11px",
    paddingLeft: "26px",
    marginTop: "-8px",
  },
});

export default useStyles;
